import { AddResourcePage, AddResourceTypePage, AdminResources, AdminResourceTypes } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

const adminGuards = () => [
  new RequiresAuthGuard(true),
  new RequiresUsertypesGuard(['agency-owner', 'internal-admin', 'system-admin']),
]

export default [
  RouteFactory.create(AdminResources, '/admin-resources', adminGuards(), {
    name: 'Admin - Manage Agent Resources',
  }),
  RouteFactory.create(AddResourcePage, '/add-resource', adminGuards(), {
    name: 'Admin - Add New Agent Resource',
  }),
  RouteFactory.create(
    AddResourcePage,
    {
      path: '/add-resource/:id/edit',
      pattern: /^\/add-resource\/\d+\/edit(\/)?$/i,
    },
    adminGuards(),
    {
      name: 'Admin - Update Resource',
    }
  ),
  RouteFactory.create(AdminResourceTypes, '/admin-resourceType', adminGuards(), {
    name: 'Admin - Manage Resource Types',
  }),
  RouteFactory.create(AddResourceTypePage, '/add-resourceType', adminGuards(), {
    name: 'Admin - Add New Agent Resource Type',
  }),
  RouteFactory.create(
    AddResourceTypePage,
    {
      path: '/add-resourceType/:id/edit',
      pattern: /^\/add-resourceType\/\d+\/edit(\/)?$/i,
    },
    adminGuards(),
    {
      name: 'Admin - Update Resource Type',
    }
  ),
]
